import { Component, OnInit, Input } from '@angular/core';
import { MessageService, LazyLoadEvent } from 'primeng/api';
import { ConfigService, StoreService } from 'app/services';
import { Utils } from 'app/utils';
import { CustomWindow } from 'app/@types';
import { TableLazyLoadEvent } from 'primeng/table';

declare let window: CustomWindow;

@Component({
    selector: 'partner-mart-locations-groups',
    templateUrl: './partner-mart-locations-groups.component.html',
    styleUrls: ['./partner-mart-locations-groups.component.scss'],
    providers: [MessageService]
})
export class PartnerMartLocationsGroupsComponent implements OnInit {
    public adminUrl: string = window['adminUrl'];

    @Input()
    public merchantId: number = 0;

    @Input()
    public onSelectGroup: (group: any) => void = () => { };

    public groups: Array<any> = [];
    public groupsLoaded: boolean = false;

    public cols: any[] = [
        { field: 'Id', header: 'Group ID', width: '200px' },
        { field: 'Name', header: 'Group Name', width: '200px' },
        { field: 'Stores', header: 'Group Stores', width: '200px', disableSort: true },
        { field: 'CreatedAt', header: 'Created Date', width: '200px' },
        { field: 'StatusName', header: 'Group Status', width: '200px' }
    ];

    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public isCreateGroupPopupVisible: boolean = false;

    public isSpinnerVisible: boolean = true;

    constructor(
        private messageService: MessageService,
        public configService: ConfigService,
        private storeService: StoreService) {
        this.onCreateGroupPopupSave = this.onCreateGroupPopupSave.bind(this);
        this.onCreateGroupPopupHide = this.onCreateGroupPopupHide.bind(this);
    }

    ngOnInit(): void {
    }

    handleLazyLoad(event: TableLazyLoadEvent): void {
        //event.first = First row offset
        //event.rows = Number of rows per page
        //event.sortField = Field name to sort in single sort mode
        //event.sortOrder = Sort order as number, 1 for asc and -1 for dec in single sort mode
        //multiSortMeta: An array of SortMeta objects used in multiple columns sorting. Each SortMeta has field and order properties.
        //filters: Filters object having field as key and filter value, filter matchMode as value
        //globalFilter: Value of the global filter if available

        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.getGroups(skip);
    }

    private getGroups(skip: number): void {
        this.isSpinnerVisible = true;

        const dto = {
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };

        this.storeService.getStoreGroupsForGrid(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;

                this.groups = data.Groups.map((x: any) => {
                    x.CreatedAt = Utils.utcToLocaleDateString(x.CreatedAt);
                    return x;
                });

                this.isSpinnerVisible = false;

                this.groupsLoaded = true;
            });
    }

    public onCreateGroupClick(): void {
        this.isCreateGroupPopupVisible = true;
    }

    public onCreateGroupPopupSave(): void {
        this.getGroups(0);

        this.isCreateGroupPopupVisible = false;

        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully saved' });
    }

    public onCreateGroupPopupHide(): void {
        this.isCreateGroupPopupVisible = false;
    }

    public onSelectGroupClick(group: any): void {
        this.onSelectGroup(group);
    }
}
